var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.05 3.5H20.95C21.5299 3.5 22 3.94772 22 4.5V20.5C22 21.0523 21.5299 21.5 20.95 21.5H2.05C1.47011 21.5 1 21.0523 1 20.5V4.5C1 3.94772 1.47011 3.5 2.05 3.5ZM11.5636 12.1829L4.82958 6.7377L3.47042 8.2623L11.5768 14.8171L19.5371 8.25616L18.1629 6.74384L11.5636 12.1829Z",
    fill: "#0B61DD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill);
export default __webpack_public_path__ + "static/media/mail-fill.186c7da22a0ed4cc170a020a82fcef3f.svg";
export { ForwardRef as ReactComponent };